import type { Enum } from './generics';

export const ROUTES = {
  picker: '/applicatie-selecteren',
  chat: '/chat',
  authorize: '/authorize',
  forbidden: '/forbidden',
  unauthorized: '/unauthorized',
} as const;

export type Route = Enum<typeof ROUTES>;
